import { GetListResult } from "react-admin"
import ConstructSequelizeFilters from "../utils/ConstructSequelizeFilters"
import HttpClient from "../HttpClient"
import Op from "../interfaces/SequalizeFilters/SequalizeTypes"

export class CouponSkuService {
    async getAllCouponSku(limit: number, offset: number, filters: any, sort: {}): Promise<GetListResult<any>> {
        const { minPrice, maxPrice, ...rest } = filters;
        const where: any = ConstructSequelizeFilters(rest, ['name'], ['productType', 'couponType', 'slotSize']);
        if (minPrice !== undefined && minPrice !== '') {
            where['price'] = { ...where['price'], [Op.gte.toString()]: Number(minPrice) };
        }
        if (maxPrice !== undefined && maxPrice !== '') {
            where['price'] = { ...where['price'], [Op.lte.toString()]: Number(maxPrice) };
        }
        filters = where;
        let data = await HttpClient.get('/centaurus/v1/discount-coupon-sku/all', {
            params: {
                limit,
                offset,
                filters,
                sort
            }
        })
        return {
            data: data.data.data,
            total: data.data.count
        }
    }

    async getSkuById(skuId: number): Promise<any> {
        const data = await HttpClient.get(`/centaurus/v1/discount-coupon-sku/${skuId}`)
        return data
    }

    async activateCouponSku(skuId: number): Promise<any> {
        const data = await HttpClient.patch(`/centaurus/v1/discount-coupon-sku/${skuId}/activate`)
        return data?.data
    }

    async deactivateCouponSku(skuId: number): Promise<any> {
        const data = await HttpClient.patch(`/centaurus/v1/discount-coupon-sku/${skuId}/deactivate`)
        return data?.data
    }

    async createCouponSku(payload: any): Promise<any> {
        const data = await HttpClient.post('/centaurus/v1/discount-coupon-sku', payload)
        return data?.data
    }

    async updateCouponSku(skuId: number, payload: any): Promise<any> {
        const data = await HttpClient.patch(`/centaurus/v1/discount-coupon-sku/${skuId}`, payload)
        return data?.data
    }

    async assignCustomersToSku(skuId: number, customerIds: number[]): Promise<any> {
        const data = await HttpClient.patch(`/centaurus/user/customer/update-summary-page-combo-skuId`, { skuId, customerIds })
        return data?.data
    }
}